import { collection, getDocs } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { StaticTranslations } from "../types";

export const getStaticTranslations = async (): Promise<
  StaticTranslations[]
> => {
  const collectionRef = collection(db, "staticTranslations");

  const staticTranslationsSnapshot = await getDocs(collectionRef);

  return staticTranslationsSnapshot.docs.map(
    (doc) =>
      ({
        id: doc.id,
        ...doc.data(),
      }) as StaticTranslations,
  );
};
